import React from 'react';
import './Footer.css';
import { FaInstagram } from 'react-icons/fa';
import { FiClock, FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import { FaMobileAlt } from 'react-icons/fa';
import { useI18n } from '../../i18n/I18n';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useI18n();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section contact">
          <h2 className="footer-logo">
            MEZ ARAÇ<br />
            <span style={{ fontSize: '0.9em', letterSpacing: '0.1em' }}>KİRALAMA</span>
          </h2>
          <ul className="contact-list" aria-label="İletişim Bilgileri">
            <li>
              <FaMobileAlt className="contact-ic" />
              <a href="tel:05334904428">0533 490 44 28</a>
            </li>
            <li>
              <FiPhone className="contact-ic" />
              <a href="tel:02124680860">0212 468 08 60</a>
            </li>
            <li>
              <FiMail className="contact-ic" />
              <a href="mailto:mezkiralama@mez.com.tr">mezkiralama@mez.com.tr</a>
            </li>
            <li>
              <FiMapPin className="contact-ic contact-ic--lg" />
              <span>Hadımköy Yolu Caddesi No:232, Arnavutköy/İstanbul</span>
            </li>
            <li>
              <FiMapPin className="contact-ic contact-ic--lg" />
              <span>Şenlikköy, Florya Kavşağı No:90, 34153 Bakırköy/İstanbul</span>
            </li>
          </ul>
        </div>
        <div className="footer-section links">
          <h3>{t('footer.quick')}</h3>
          <ul>
            <li><a href="/">{t('nav.home')}</a></li>
            <li><a href="/arac-filomuz">{t('vehicles.title')}</a></li>
            <li><a href="/hakkimizda">{t('nav.about')}</a></li>
            <li><a href="/kurumsal-kiralama">{t('nav.corporate')}</a></li>
            {/* SLA kaldırıldı */}
            <li><a href="/sss">{t('faq.title')}</a></li>
            {/* KVKK kaldırıldı */}
            <li><a href="/cerez-politikasi">{t('footer.cookies')}</a></li>
            <li><a href="/iletisim">{t('contact.title')}</a></li>
          </ul>
        </div>
        <div className="footer-section map">
          <h3>{t('footer.location')}</h3>
          <div className="map-container">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.956!2d28.7975616!3d40.9855581!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa3bdb1cf6f73:0xc32233ac373e5afb!2sMez%20Oto%20Kiralama!5e0!3m2!1str!2str!4v1733577600000!5m2!1str!2str" 
              width="100%" 
              height="200" 
              style={{border: 0}} 
              allowFullScreen={true}
              loading="lazy"
              title="MEZ Araç Kiralama Konumu"
            ></iframe>
          </div>
        </div>
        <div className="footer-section hours">
          <h3><FiClock style={{ marginRight: 6, verticalAlign: 'middle' }} />{t('footer.hours')}</h3>
          <ul className="hours-list" aria-label={t('footer.hours')}>
            <li><span className="day">{t('footer.monfri')}</span><span className="time">08:00 - 17:30</span></li>
            <li><span className="day">{t('footer.sat')}</span><span className="time">08:30 - 12:30</span></li>
            <li><span className="day">{t('footer.sun')}</span><span className="time">{t('footer.closed')}</span></li>
          </ul>

          {/* Bizi Takip Edin - Çalışma saatlerinin hemen altında */}
          <div className="hours-social">
            <h4>{t('footer.follow')}</h4>
            <div className="social-icons social-icons--left">
              <a href="https://instagram.com/mezkiralama" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {currentYear} MEZ ARAÇ KİRALAMA | {t('footer.rights')}
      </div>
    </footer>
  );
};

export default Footer; 